import { useEffect, useRef, useState } from "react";
import { InfoIcon } from "lucide-react";
import { toWords } from "number-to-words";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFilledRiskProfileService, getRiskProfileService, submitRiskProfile } from "../../api/riskProfile";
import { useDocumentTitle } from "../../utils/Common";
import { useTheme } from "../../utils/theme";
import { reduxFetchUserLoginDetail } from "../../redux/auth/auth";
import { getAuthenticatedRedirectPath } from "../../utils/authRedirect";

export default function RiskProfile2() {
    const dispatch = useDispatch();
    const router = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const userId = localStorage.getItem("uid");
    const userDetail = useSelector((state) => state.auth.userDetail);
    const [hasQuestion, setHasQuestion] = useState([]);
    const [isShowTooltip, setIsShowTooltip] = useState({
        monthlyIncome: false,
        dob: false,
    });
    const firstInput = useRef(null);
    const [hasAns, setHasAns] = useState({
        userId,
        dob: "",
        occupation: "",
        investmentGoal: "",
        monthlyIncome: "",
        userAnswers: [],
    });
    const [data, setData] = useState(JSON.parse(localStorage.getItem("cz")));
    let firstKey, planName
    let answer;
    useEffect(() => {
        if (firstInput?.current) {
            firstInput?.current?.focus();
        }
        setIsLoading(false);

        getRiskProfileService()
            .then((response) => {
                setHasQuestion(response.data.data);
                let userAnswers = [];
                response.data.data.map((item) => {
                    userAnswers.push({
                        queId: item.id,
                        queCategory: item.queCategory,
                        optId: 0,
                        optSeq: "",
                        optWeight: "",
                    });
                });
                setHasAns((prevState) => {
                    answer = userAnswers;
                    return { ...prevState, userAnswers };
                });
            })
            .then(() => {
                if (userDetail.rpfProfileType) {
                    if (userDetail.rpfId)
                        getFilledRiskProfileService(userDetail.rpfId).then((response) => {
                            if (
                                (userDetail.rpfProfileType === "Aggressive" ||
                                    userDetail.email === null) && response.isOnline
                            ) {
                                router("/dashboard");
                            }
                            // setHasAns((prevState) => {
                            //   return {
                            //     ...prevState,
                            //     dob: response.dob,
                            //     investmentGoal: response.investmentGoal,
                            //     monthlyIncome: response.monthlyIncome,
                            //     occupation: response.occupation,
                            //     userAnswers: response.isOnline
                            //       ? response.userAnswers
                            //       : answer,
                            //     userId: response.userId,
                            //   };
                            // });
                        });
                }
            });

        // const storedData = localStorage.getItem("cz");
        // if (storedData) {
        //   setData(JSON.parse(storedData));
        // }
    }, [dispatch, userDetail]);

    if (data?.planData && Object.keys(data.planData).length > 0) {
        firstKey = Object.keys(data.planData)[0];
        planName = data.planData[firstKey]?.name || data.planData[firstKey]?.bundleName;
    }
    const isHidden =
        !data || !data.planData || Object.keys(data.planData).length === 0
            ? false
            : true;
    // const isHidden = "d-none"
    const updateAns = (params) => {
        setHasAns((prevState) => {
            const { queId, queCategory, optId, optSeq, optWeight, isAuto } = params;
            let userAnswersCloned = [...hasAns.userAnswers];
            const index = hasAns.userAnswers.findIndex(
                (item) => item.queId === queId
            );
            if (index !== -1) {
                userAnswersCloned[index] = {
                    queId,
                    queCategory,
                    optId,
                    optSeq,
                    optWeight,
                    isAuto
                };
            }
            return { ...prevState, userAnswers: userAnswersCloned };
        });
    };

    const submitRPF = (e) => {
        e.preventDefault();
        setIsLoading(true);

        // 🔥 Remove isAuto key before sending
        const cleanedPayload = {
            ...hasAns,
            userAnswers: hasAns.userAnswers.map(({ isAuto, ...rest }) => rest)
        };

        submitRiskProfile(cleanedPayload)
            .then(async () => {
                return dispatch(reduxFetchUserLoginDetail(userId));
            })
            .then((response) => {
                const refreshedUserDetail = response?.payload?.data?.data || userDetail;
                setIsLoading(false);
                isHidden
                    ? (window.location.href = "/checkout")
                    : (window.location.href = getAuthenticatedRedirectPath(refreshedUserDetail));
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    useDocumentTitle("Risk Profile");
    const totalDropdowns = 4;
    const totalManualRadios = 6; // only manual radios

    const isValid = (value) =>
        value !== null && value !== undefined && value !== "";

    // Dropdown count
    const dropdownCount =
        (isValid(hasAns.dob) ? 1 : 0) +
        (isValid(hasAns.occupation) ? 1 : 0) +
        (isValid(hasAns.investmentGoal) ? 1 : 0) +
        (isValid(hasAns.monthlyIncome) ? 1 : 0);

    // Count only manual radio answers
    const radioCount = hasAns.userAnswers.filter(
        (item) => item?.optId && !item?.isAuto
    ).length;

    const totalQuestions = totalDropdowns + totalManualRadios;

    const answeredCount = dropdownCount + radioCount;

    const progress = Math.min(
        (answeredCount / totalQuestions) * 100,
        100
    );

    const { theme, isDark } = useTheme();
    const primaryThemeButtonClass = "btn";
    const primaryThemeButtonStyle = {
        backgroundColor: "var(--bs-emphasis-color)",
        borderColor: "var(--bs-emphasis-color)",
        color: "var(--bs-body-bg)",
    };
    if (isLoading && false) {
        return <div></div>;
    } else {
        return (
            // <Layout>
            <section class={isDark ? "welcome-hero-dark-section py-4" : "welcome-hero-light py-4"}>
                <div class="container">
                    <div class={isDark ? "welcome-hero-dark-border rounded-3" : "welcome-hero-light-border rounded-3"}>
                        <div class="row g-0 justify-content-between align-items-top">
                            <div class="col-md-4">
                                <div class={isDark ? "welcome-hero-dark p-3 h-100" : "welcome-hero-light-section p-3 h-100"}>
                                    <a class="text-decoration-none" href="./">
                                        <img loading="lazy" class="img-fluid w-75"
                                            src={
                                                theme == "dark"
                                                    ? "https://equitypandit.in/ep-wealth/25.svg"
                                                    : "https://equitypandit.in/ep-imgs/ep-advisor-logo.svg"
                                            }
                                            alt="EP-Investment-Advisor" />
                                    </a>
                                    <p><small>SEBI Registration No. INA000006688</small></p>
                                    <h1 class="fw-bold mb-3">Let's quickly check if our service is right fit for you</h1>
                                    <div class="d-none d-md-block">
                                        <p class="mt-3 mb-3">Answer a few questions to generate a personalized investment plan</p>
                                        <p class="mt-4"><i class="fa fa-clock"></i> Takes under 2 minutes</p>
                                        <p><i class="fa fa-lock"></i> 100% Confidential</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class=" rounded-3 h-100">
                                    <div class="p-3 sticky-top">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <p class="fw-bold mb-0">Risk Profile</p>
                                                <small class="text-muted">{progress}% completed</small>
                                            </div>
                                            <button
                                                className={primaryThemeButtonClass}
                                                style={primaryThemeButtonStyle}
                                                disabled={
                                                    !(progress >= 100 &&
                                                        window.hasAge >= 18 &&
                                                        hasAns?.monthlyIncome >= 10000)
                                                }
                                                onClick={(e) => submitRPF(e)}
                                            >
                                                Continue
                                            </button>
                                        </div>
                                        <div
                                            className="progress mt-2"
                                            role="progressbar"
                                            aria-valuenow={progress}
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            style={{ height: "5px" }}
                                        >
                                            <div
                                                className="progress-bar bg-success"
                                                style={{
                                                    width: `${progress}%`,
                                                    transition: "width 0.3s ease"
                                                }}
                                            ></div>
                                        </div>

                                    </div>

                                    <div class="p-3 overflow-auto" style={{ "max-height": "80vh" }}>
                                        {/* <!-- RPF: START --> */}
                                        <div className="row g-3">
                                            <div className="col-md-6 fw-bold ">
                                                <div>
                                                    <div className="d-flex justify-content-between">
                                                        <label
                                                            className="mb-1  rpf_question"
                                                            htmlFor="dob"
                                                        >
                                                            <small>Date of Birth</small>
                                                        </label>
                                                        {/* <a
                              href="#"
                              onMouseEnter={() =>
                                setIsShowTooltip({
                                  ...isShowTooltip,
                                  dob: true,
                                })
                              }
                              onMouseLeave={() =>
                                setIsShowTooltip({
                                  ...isShowTooltip,
                                  dob: false,
                                })
                              }
                            >
                              <InfoIcon size={20} className="font-primary" />
                            </a>

                            {isShowTooltip.dob && (
                              <div
                                className="tooltip bs-tooltip-auto fade show"
                                role="tooltip"
                                style={{
                                  position: "absolute",
                                  inset: "0px auto auto -712px",
                                  margin: "0px",
                                  transform: "translate(1145px, 240px)",
                                }}
                                data-popper-placement="right"
                              >
                                <div
                                  className="tooltip-arrow"
                                  style={{
                                    position: "absolute",
                                    top: "-64px",
                                    transform: "translate(0px, 100px)",
                                  }}
                                ></div>
                                <div className="tooltip-inner">
                                  Why do we require your birth date? <br /> Date
                                  of birth is a key factor in assessing your risk
                                  profile. It helps us determine the most suitable
                                  level of risk for your investments based on your
                                  age and financial objectives.
                                </div>
                              </div>
                            )} */}
                                                    </div>
                                                    <input
                                                        ref={firstInput}
                                                        type="date"
                                                        className="shadow-none py-2 form-control text-black dob"
                                                        required={true}
                                                        name="dob"
                                                        id="dob"
                                                        // max="2006-07-17"
                                                        value={hasAns.dob}
                                                        placeholder="DD-MM-YYYY"
                                                        onChange={(e) => {
                                                            setHasAns({ ...hasAns, dob: e.target.value });
                                                            window.hasAge = moment().diff(
                                                                // moment(e.target.value, "DD-MM-YYYY"),
                                                                moment(e.target.value, "YYYY-MM-DD"),
                                                                "years"
                                                            );
                                                            let optId, optSeq, optWeight, isAuto;
                                                            if (window.hasAge <= 23) {
                                                                optId = 1;
                                                                optSeq = "A";
                                                                optWeight = "2";
                                                                isAuto = true;
                                                            } else if (window.hasAge > 23 && window.hasAge <= 40) {
                                                                optId = 2;
                                                                optSeq = "B";
                                                                optWeight = "4";
                                                                isAuto = true;
                                                            } else if (window.hasAge > 40 && window.hasAge <= 60) {
                                                                optId = 3;
                                                                optSeq = "C";
                                                                optWeight = "3";
                                                                isAuto = true;
                                                            } else if (window.hasAge > 60) {
                                                                optId = 4;
                                                                optSeq = "D";
                                                                optWeight = "1";
                                                                isAuto = true;
                                                            }
                                                            updateAns({
                                                                queId: 1,
                                                                queCategory: "WILLINGNESS TO TAKE RISK",
                                                                optId,
                                                                optSeq,
                                                                optWeight,
                                                                isAuto
                                                            });
                                                        }}
                                                    />
                                                    <small
                                                        id="currencyOutput"
                                                        className={`${(window.hasAge == undefined || window.hasAge < 18) ? "text-danger" : "text-success"
                                                            }`}
                                                    >
                                                        {" "}
                                                        {(window.hasAge == undefined || window.hasAge < 18)
                                                            ? "Minimum age 18 years required"
                                                            : `You're ${window.hasAge} years old`}
                                                    </small>
                                                    <span className="dob_error_msg"></span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 fw-bold">
                                                <div>
                                                    <label
                                                        className="mb-1  rpf_question"
                                                        htmlFor="occupation-radio"
                                                    >
                                                        <small>Occupation</small>
                                                    </label>
                                                    <select
                                                        name="occupation-radio"
                                                        id="occupation-radio"
                                                        required={true}
                                                        value={hasAns.occupation}
                                                        className="form-select"
                                                        onChange={(e) => {
                                                            setHasAns({
                                                                ...hasAns,
                                                                occupation: e.target.value,
                                                            });
                                                            const input = e.target.value;
                                                            let optId, optSeq, optWeight, isAuto;
                                                            if (input === "Business or Professional") {
                                                                optId = 5;
                                                                optSeq = "A";
                                                                optWeight = "5";
                                                                isAuto = true;
                                                            } else if (
                                                                input === "Service - Private or Public Sector"
                                                            ) {
                                                                optId = 6;
                                                                optSeq = "B";
                                                                optWeight = "4";
                                                                isAuto = true;
                                                            } else if (input === "Government Job") {
                                                                optId = 7;
                                                                optSeq = "C";
                                                                optWeight = "3";
                                                                isAuto = true;
                                                            } else if (input === "Retired") {
                                                                optId = 8;
                                                                optSeq = "D";
                                                                optWeight = "2";
                                                                isAuto = true;
                                                            } else if (input === "Housewife") {
                                                                optId = 9;
                                                                optSeq = "E";
                                                                optWeight = "1";
                                                                isAuto = true;
                                                            }
                                                            updateAns({
                                                                queId: 2,
                                                                queCategory: "FINANCIAL CAPABILITY",
                                                                optId,
                                                                optSeq,
                                                                optWeight,
                                                                isAuto
                                                            });
                                                        }}
                                                    >
                                                        <option value="">-- Select --</option>
                                                        <option value="Business or Professional">
                                                            Business or Professional
                                                        </option>
                                                        <option value="Service - Private or Public Sector">
                                                            Service - Private or Public Sector
                                                        </option>
                                                        <option value="Government Job">Government Job</option>
                                                        <option value="Retired">Retired</option>
                                                        <option value="Housewife">Housewife</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 fw-bold">
                                                <div>
                                                    <label
                                                        className="mb-1  rpf_question"
                                                        htmlFor="investment-goals-radio"
                                                    >
                                                        <small>Investment Goals</small>
                                                    </label>
                                                    <select
                                                        name="investment-goals-radio"
                                                        id="investment-goals-radio"
                                                        required={true}
                                                        value={hasAns.investmentGoal}
                                                        className="form-select"
                                                        onChange={(e) => {
                                                            setHasAns({
                                                                ...hasAns,
                                                                investmentGoal: e.target.value,
                                                            });
                                                            const input = e.target.value;
                                                            let optId, optSeq, optWeight, isAuto;
                                                            if (input === "Capital Appreciation") {
                                                                optId = 10;
                                                                optSeq = "A";
                                                                optWeight = "2";
                                                                isAuto = true;
                                                            } else if (
                                                                input ===
                                                                "Regular Income while taking calculated risk"
                                                            ) {
                                                                optId = 11;
                                                                optSeq = "B";
                                                                optWeight = "3";
                                                                isAuto = true;
                                                            } else if (input === "Combination Of all") {
                                                                optId = 12;
                                                                optSeq = "C";
                                                                optWeight = "3";
                                                                isAuto = true;
                                                            }
                                                            updateAns({
                                                                queId: 3,
                                                                queCategory: "WILLINGNESS TO TAKE RISK",
                                                                optId,
                                                                optSeq,
                                                                optWeight,
                                                                isAuto
                                                            });
                                                        }}
                                                    >
                                                        <option value="">-- Select --</option>
                                                        <option value="Capital Appreciation">
                                                            Capital Appreciation
                                                        </option>
                                                        <option value="Regular Income while taking calculated risk">
                                                            Regular Income while taking calculated risk
                                                        </option>
                                                        <option value="Combination Of all">
                                                            Combination Of all
                                                        </option>
                                                    </select>
                                                    <span className="text-danger investment-goals-radio_error_msg"></span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 fw-bold">
                                                <div>
                                                    <div className="d-flex justify-content-between">
                                                        <label
                                                            className="mb-1  rpf_question"
                                                            htmlFor="monthly-income-radio"
                                                        >
                                                            <small>Monthly Income</small>
                                                        </label>
                                                        {/* <a
                              href="#"
                              onMouseEnter={() =>
                                setIsShowTooltip({
                                  ...isShowTooltip,
                                  monthlyIncome: true,
                                })
                              }
                              onMouseLeave={() =>
                                setIsShowTooltip({
                                  ...isShowTooltip,
                                  monthlyIncome: false,
                                })
                              }
                            >
                              <InfoIcon size={20} className="font-primary" />
                            </a>

                            {isShowTooltip.monthlyIncome && (
                              <div
                                className="tooltip bs-tooltip-auto fade show"
                                role="tooltip"
                                style={{
                                  position: "absolute",
                                  inset: "0px auto auto 0px",
                                  margin: "0px",
                                  transform: "translate(1145px, 240px)",
                                }}
                                data-popper-placement="right"
                              >
                                <div
                                  className="tooltip-arrow"
                                  style={{
                                    position: "absolute",
                                    top: "-64px",
                                    transform: "translate(0px, 100px)",
                                  }}
                                ></div>
                                <div className="tooltip-inner">
                                  Why do we require your monthly income? <br />
                                  Income is a fundamental aspect as it aids us in
                                  determining the right level of risk for your
                                  investments/trading, taking into account your
                                  financial capability and long-term financial
                                  goals.
                                </div>
                              </div>
                            )} */}
                                                    </div>
                                                    <input
                                                        id="monthly-income-radio"
                                                        type="text"
                                                        maxLength={12}
                                                        className="shadow-none py-2 form-control text-black"
                                                        required={true}
                                                        value={hasAns.monthlyIncome}
                                                        // placeholder="> 15000"
                                                        onChange={(e) => {
                                                            if (!isNaN(e.target.value)) {
                                                                const yearlyIncome = +e.target.value * 12;
                                                                let optId, optSeq, optWeight, isAuto;
                                                                if (yearlyIncome < 500000) {
                                                                    optId = 14;
                                                                    optSeq = "A";
                                                                    optWeight = "1";
                                                                    isAuto = true;
                                                                } else if (
                                                                    yearlyIncome >= 500000 &&
                                                                    yearlyIncome < 1000000
                                                                ) {
                                                                    optId = 15;
                                                                    optSeq = "B";
                                                                    optWeight = "2";
                                                                    isAuto = true;
                                                                } else if (
                                                                    yearlyIncome >= 1000000 &&
                                                                    yearlyIncome < 2500000
                                                                ) {
                                                                    optId = 16;
                                                                    optSeq = "C";
                                                                    optWeight = "3";
                                                                    isAuto = true;
                                                                } else if (yearlyIncome >= 2500000) {
                                                                    optId = 17;
                                                                    optSeq = "D";
                                                                    optWeight = "4";
                                                                    isAuto = true;
                                                                }
                                                                setHasAns((prevState) => ({
                                                                    ...prevState,
                                                                    monthlyIncome: e.target.value,
                                                                }));
                                                                // setHasAns({...hasAns, monthlyIncome: String(input).slice(0,12)})
                                                                updateAns({
                                                                    queId: 4,
                                                                    queCategory: "FINANCIAL CAPABILITY",
                                                                    optId,
                                                                    optSeq,
                                                                    optWeight,
                                                                    isAuto
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    {hasAns.monthlyIncome && (
                                                        <small
                                                            id="currencyOutput"
                                                            className={`text-capitalize ${hasAns.monthlyIncome < 10000
                                                                ? "text-danger"
                                                                : "text-success"
                                                                }`}
                                                        >
                                                            {hasAns.monthlyIncome < 10000 &&
                                                                "Minimum ten thousand monthly income required but "}{" "}
                                                            {hasAns.monthlyIncome < 10000
                                                                ? "Your monthly income is "
                                                                : ""}
                                                            {hasAns.monthlyIncome &&
                                                                toWords(+hasAns.monthlyIncome ?? 0)}{" "}
                                                            only.
                                                        </small>
                                                    )}
                                                    <span className="text-danger monthly-income-radio_error_msg"></span>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                {/* <div className="card border-0"> */}
                                                <div className="row justify-content-center g-3">
                                                    {hasQuestion.map((item, index) => {
                                                        if (![1, 2, 3, 4].includes(index + 1))
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="col-md-6 p-1 h-100"
                                                                >
                                                                    <div className="p-1">
                                                                        <small className="fw-bold">
                                                                            {item.question}
                                                                        </small>
                                                                        <div className="row g-3 mt-1">
                                                                            {(item?.options || []).map(
                                                                                (item2, index2) => (
                                                                                    <div
                                                                                        className="col-md-12"
                                                                                        onClick={() =>
                                                                                            updateAns({
                                                                                                queId: item2.queId,
                                                                                                queCategory: item.queCategory,
                                                                                                optId: item2.id,
                                                                                                optSeq: item2.optSeq,
                                                                                                optWeight: item2.optWeight,
                                                                                            })
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            className={` form-check p-2 border bg-white rounded-3 ${hasAns?.userAnswers[index]
                                                                                                ?.optSeq === item2?.optSeq
                                                                                                ? "border-success border-2"
                                                                                                : ""
                                                                                                }`}
                                                                                            key={index2}
                                                                                        >
                                                                                            <input
                                                                                                id={item2.queId + item2.id}
                                                                                                name={item2.queId}
                                                                                                type="radio"
                                                                                                checked={
                                                                                                    hasAns?.userAnswers[index]
                                                                                                        ?.optSeq === item2?.optSeq
                                                                                                }
                                                                                                className="form-check-input mx-2"
                                                                                                required={true}
                                                                                            // onChange={() =>
                                                                                            //   updateAns({
                                                                                            //     queId: item2.queId,
                                                                                            //     queCategory: item.queCategory,
                                                                                            //     optId: item2.id,
                                                                                            //     optSeq: item2.optSeq,
                                                                                            //     optWeight: item2.optWeight,
                                                                                            //   })
                                                                                            // }
                                                                                            />
                                                                                            <small
                                                                                                className="form-check-label"
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    userSelect: "none",
                                                                                                }}
                                                                                                htmlFor={item2.queId + item2.id}
                                                                                                onClick={() =>
                                                                                                    updateAns({
                                                                                                        queId: item2.queId,
                                                                                                        queCategory:
                                                                                                            item.queCategory,
                                                                                                        optId: item2.id,
                                                                                                        optSeq: item2.optSeq,
                                                                                                        optWeight: item2.optWeight,
                                                                                                    })
                                                                                                }
                                                                                            >
                                                                                                {item2.optText}
                                                                                            </small>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                    })}

                                                    <div className="col-md-3 d-none text-center p-3">
                                                        <button
                                                            id="submit"
                                                            className="btn btn-success text-uppercase w-75 mt-3"
                                                            type="submit"
                                                            disabled={isLoading || window.hasAge < 18}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                        {/* <!-- RPF: END --> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            // </Layout>
        );
    }
}
